import { createFileRoute, redirect, Outlet } from '@tanstack/react-router'
import { useAuthStore } from '../../stores/authStore'
import { AdminSidebar } from '../../features/admin/AdminSidebar'
import { PageLoading } from '../../components/PageLoading'
import { toastError } from '../../hooks/useToast'

/* ───── Route Definition ───── */

export const Route = createFileRoute('/_authenticated/admin')({
  beforeLoad: async () => {
    const state = useAuthStore.getState()

    // Wait for initial auth check to complete
    if (state.isLoading) {
      await new Promise<void>((resolve) => {
        const unsub = useAuthStore.subscribe((s) => {
          if (!s.isLoading) {
            unsub()
            resolve()
          }
        })
      })
    }

    const { user, isAuthenticated } = useAuthStore.getState()

    if (!isAuthenticated) {
      throw redirect({
        to: '/login',
      })
    }

    // Check admin role
    const adminRoles = ['admin', 'collection_manager']
    if (!user || !adminRoles.includes(user.role)) {
      // Show toast notification for unauthorized access
      toastError('You do not have admin access')

      throw redirect({
        to: '/dashboard',
        search: { reason: 'unauthorized' },
      })
    }
  },
  component: AdminLayout,
  pendingComponent: () => <PageLoading message="Checking permissions..." />,
})

/* ───── Admin Layout ───── */

function AdminLayout() {
  return (
    <div className="flex h-full" data-testid="admin-layout">
      <AdminSidebar />
      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  )
}
